import { render } from "./CotisationTableInd.vue?vue&type=template&id=31f4688f"
import script from "./CotisationTableInd.vue?vue&type=script&lang=js"
export * from "./CotisationTableInd.vue?vue&type=script&lang=js"

import "./CotisationTableInd.vue?vue&type=style&index=0&id=31f4688f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__